<!-- Header -->
<div class="sticky-top shadow-sm">
  <div class=" py-1 bg-white border-bottom border-light">
    <div class="container">
      <div class="icon-bar d-flex gap-3 fs-5 justify-content-end ">
        <a href="https://www.facebook.com/profile.php?id=61578332763717" aria-label="facebook" target="_blank"><i
            class="bi bi-facebook"></i></a>
        <a href="https://www.linkedin.com/in/codedialog/" aria-label="linkedin" target="_blank"><i
            class="bi bi-linkedin"></i></a>
        <a href="https://www.instagram.com/codedialog/" aria-label="instagram" target="_blank"><i
            class="bi bi-instagram"></i></a>
        <!--         <a href="#" aria-label="twitter"><i class="bi bi-twitter-x"></i></a> -->
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg  py-3">
    <div class="container">
      <a class="navbar-brand brand-mark" href="#">
        <img src="assets/img/cd-logo.png">
      </a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#nav" aria-controls="nav"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="nav">
        <ul class="navbar-nav ms-auto align-items-lg-center gap-lg-3">
          <li class="nav-item"><a class="nav-link" (click)="scrollTo('mission')">Mission</a></li>
          <li class="nav-item"><a class="nav-link" (click)="scrollTo('vision')">Vision</a></li>
          <li class="nav-item"><a class="nav-link" (click)="scrollTo('values')">Values</a></li>
          <li class="nav-item"><a class="nav-link" (click)="scrollTo('productservices')">Products & Services</a></li>
          <li class="nav-item"><a class="nav-link" (click)="scrollTo('contactus')">Contact us</a></li>
        </ul>
      </div>
    </div>
  </nav>
</div>

<!-- Hero -->
<div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active"
      aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="assets/img/slid1.jpg" class="d-block w-100" alt="...">
      <div class="carousel-caption">
        <div class="h-100 d-flex align-items-center">
          <div class="row align-items-center">
            <div class="col-lg-10 hero" data-aos="fade-up">
              <h1 class="display-4 mb-3 text-white text-primary">Enhancing the
                customer
                expectations
              </h1>
              <h2 class="text-white">The future is here. Explore our cutting-edge products and
                services.
              </h2>
              <p class="lead">CDS combine business and design services with deep technical
                proficiency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <img src="assets/img/slid2.jpg" class="d-block w-100" alt="...">
      <div class="carousel-caption">
        <div class="h-100 d-flex align-items-center hero-div">
          <div class="row">
            <div class="col-lg-10 hero" data-aos="fade-up">
              <h1 class="display-4 mb-3 text-white text-primary">The complete solution</h1>
              <h2 class="text-white">We design and develop solutions
                that makes people’s lives SIMPLE.
              </h2>
              <p class="lead">We approach to every challenge with best fresh thought to meet our
                client’s expectation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <img src="assets/img/slid3.jpg" class="d-block w-100" alt="...">
      <div class="carousel-caption">
        <div class="h-100 d-flex align-items-center">
          <div class="row align-items-center">
            <div class="col-lg-10 hero" data-aos="fade-up">
              <h1 class="display-4 mb-3 text-white text-primary">Solutions to
                every key
                problem in software
              </h1>
              <h2 class="text-white">If plan ‘A’ didn’t work. The alphabet
                has 25 more letters. Catch us!
              </h2>
              <p class="lead">We help our clients provide compelling experiences across the entire
                software lifecycle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<!-- About Us -->
<section id="about">
  <div class="container">
    <div class="row g-4 align-items-center">
      <div class="col-md-4" data-aos="fade-right">
        <img class="img-fluid rounded-2xl shadow-soft" alt="Team collaborating" src="assets/img/about.jpg" />
      </div>
      <div class="col-md-8" data-aos="fade-left">
        <small class="text-uppercase fw-bold text-primary">About us</small>
        <h2 class="mt-2 mb-3">We Make Solutions Combining Strategy</h2>
        <p>Our goal is to provide the complete solutions to our clients and enhance their business by
          solving their great business
          problems. We approach to every challenge with best fresh
          thought to meet our client expectations and provide best services.</p>
      </div>
    </div>
  </div>
</section>

<!-- Mission & Vision -->
<section class="bg-mv">
  <div class="container">
    <div class="row mb-4 g-0 rounded overflow-hidden" data-aos="zoom-in" id="mission">
      <div class="col-md-3 col-lg-3 d-none d-md-block">
        <img class="img-fluid  shadow-soft h-100" style="object-fit:cover" alt="Gears and team"
          src="assets/img/mission.jpg" />
      </div>
      <div class="col-md-9 col-lg-9">
        <div class="p-4 p-lg-5 bg-light  shadow-soft h-100">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="icon shadow-soft"><i class="bi bi-lightbulb"></i></div>
            <h3 class="mb-0">Mission</h3>
          </div>
          <p>CDS is committed to provide innovative technical business solutions, application development,
            product development and accomplish the vision by following our four pillars of Technology,
            Commitment, Quality and Accountability.</p>
        </div>
      </div>
    </div>
    <div class="row g-0 rounded overflow-hidden" data-aos="zoom-in" id="vision">

      <div class="col-md-9 col-lg-9" data-aos-delay="100">
        <div class="p-4 p-lg-5 bg-light  shadow-soft h-100">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="icon shadow-soft"><i class="bi bi-binoculars"></i></div>
            <h3 class="mb-0">Vision</h3>
          </div>
          <p>To be the most admired company, reaching the global customers by understanding the rapidly
            changing requirements and deliver on- time world class solutions, products and services,
            fulfilling commitments and consistently.</p>
        </div>
      </div>
      <div class="col-md-3 col-lg-3 d-none d-md-block">
        <img class="img-fluid shadow-soft h-100" style="object-fit:cover" alt="Gears and team"
          src="assets/img/vision.jpg" />
      </div>
    </div>
  </div>
</section>

<!-- Values -->
<section id="values">
  <div class="container">
    <div class="text-center mb-5" data-aos="fade-up">
      <small class="text-uppercase fw-bold text-primary">Values</small>
      <h2 class="mt-2">To embody these core values in our leadership</h2>
    </div>

    <div class="row g-4 align-items-stretch">
      <div class="col-lg-6" data-aos="fade-right">
        <img class="img-fluid rounded-2xl shadow-soft h-100" style="object-fit:cover" alt="Gears and team"
          src="assets/img/value.jpg" />
      </div>
      <div class="col-lg-6" data-aos="fade-left">
        <div class="card card-feature bg-primary text-white h-100">
          <div class="card-body p-4 p-lg-5">
            <div class="d-flex align-items-start gap-3 mb-4"><i class="bi bi-stars fs-3"></i>
              <div>
                <h5 class="mb-1 text-white">Creativity</h5>
                <p class="mb-0">We ideate boldly and ship thoughtfully.</p>
              </div>
            </div>
            <div class="d-flex align-items-start gap-3 mb-4"><i class="bi bi-arrow-repeat fs-3"></i>
              <div>
                <h5 class="mb-1 text-white">Adaptability</h5>
                <p class="mb-0">We learn fast and evolve faster.</p>
              </div>
            </div>
            <div class="d-flex align-items-start gap-3 mb-4"><i class="bi bi-people fs-3"></i>
              <div>
                <h5 class="mb-1 text-white">Collaboration</h5>
                <p class="mb-0">We win together with our clients.</p>
              </div>
            </div>
            <div class="d-flex align-items-start gap-3"><i class="bi bi-graph-up-arrow fs-3"></i>
              <div>
                <h5 class="mb-1 text-white">Better decisions & accepting challenges</h5>
                <p class="mb-0">We make data‑driven decisions and tackle the hard problems.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Products & Services -->
<section id="productservices" class="bg-muted">
  <div class="container">
    <div class="text-center mb-5" data-aos="fade-up">
      <small class="text-uppercase fw-bold text-primary">Products and Services</small>
      <h2 class="mt-2">Services That Fit Your Needs</h2>
    </div>
    <div class="row g-4">
      <div class="col-lg-6" data-aos="fade-up" data-aos-delay="50">
        <div class="card rounded-2xl shadow-soft border-0 h-100">

          <img class="card-img-top p-4" src="assets/img/products.jpg">

          <div class="card-body text-center">
            <h4 class="mb-3">Products</h4>
            <p>Across the market we provide solutions to every key problem in software world. We help
              our client’s provide compelling experiences across the entire software lifecycle and
              research.
            </p>
          </div>
          <ul>
            <li>view our complete solution for Charted Accountants - <a href="https://capdatapro.com/"
                target="_blank">CAPDATA Pro</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-6" data-aos="fade-up" data-aos-delay="150">
        <div class="card rounded-2xl shadow-soft border-0 h-100">

          <img class="card-img-top p-4" src="assets/img/services.png">

          <div class="card-body text-center">
            <h4 class="mb-3">Services</h4>
            <p>Technology is getting updated at rocket speed and enhancing the customer expectations,
              prompting brands to rethink how they engage and retain customers. CDS combine business
              and design services with deep technical proficiency to create best customer experiences.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="text-center position-relative " style="top: 2.5em;"><span class=" text-uppercase text-primary">Total
      Visitors</span>&nbsp;&nbsp;{{totalCount || 0}}</div>
</section>


<!-- Contact -->
<section class="py-0" id="contactus">
  <div class="map-wrap">
    <img src="assets/img/map.jpg" class="w-100" alt="World map" />
    <div class="contact-card">
      <div class="card shadow-soft rounded-2xl" data-aos="fade-up">
        <div class="card-body p-4">
          <small class="text-uppercase fw-bold text-primary">Contact Us</small>
          <h5 class="mb-3">Have a Project Idea? <span class="text-primary">Let's Talk!</span></h5>
          <form [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">
            <div class="mb-3">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" placeholder="Your name*" formControlName="name" />
              <div *ngIf="myForm.get('name')?.invalid && myForm.get('name')?.touched" class="error">
                Name is required.
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input type="text" class="form-control" placeholder="Your email*" formControlName="email" />
              <div *ngIf="myForm.get('email')?.invalid && myForm.get('email')?.touched" class="error">
                Email is required.
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Phone</label>
              <input type="text" class="form-control" placeholder="Your phone number" formControlName="phone" />
              <div *ngIf="myForm.get('phone')?.invalid" class="error">
                Enter a valid phone number.
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Message</label>
              <textarea class="form-control" rows="3" placeholder="Tell us about your project..."
                formControlName="message"></textarea>
            </div>
            <button type="submit" class="btn btn-primary w-100" [disabled]="loading"><span
                *ngIf="!loading">Enquiry</span><span *ngIf="loading">Sending...</span></button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="pt-5 pb-4 mt-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-lg-4">
        <div class="f-logo mb-2">
          <img src="assets/img/cd-logo.png">
        </div>
        <p>15+
          years of experience in designing,
          developing, and implementing
          software solutions.</p>





        <div class="d-flex gap-3 fs-5">
          <a href="https://www.facebook.com/profile.php?id=61578332763717" aria-label="facebook" target="_blank"><i
              class="bi bi-facebook"></i></a>
          <a href="https://www.linkedin.com/in/codedialog/" aria-label="linkedin" target="_blank"><i
              class="bi bi-linkedin"></i></a>
          <a href="https://www.instagram.com/codedialog/" aria-label="instagram" target="_blank"><i
              class="bi bi-instagram"></i></a>
          <!--         <a href="#" aria-label="twitter"><i class="bi bi-twitter-x"></i></a> -->
        </div>
      </div>
      <div class="col-lg-5">
        <h6 class="text-white">Contact Info</h6>
        <ul class="list-unstyled small mb-0">
          <li># 9-21-14, Cabin# 10, 2nd floor, Srinilayam, CBM Compound,
            Srinivasa Nagar, Visakhapatnam, Andhra Pradesh 530003, India.</li>
          <li><i class="bi bi-envelope-fill me-2"></i><a
              href="mailto:enquiry&#64;codedialog.com">enquiry&#64;codedialog.com</a>
          </li>
          <li> <i class="bi bi-phone-fill me-2"></i><a href="tel:+911234567890">+91 7013721282</a></li>
        </ul>
      </div>
      <div class="col-lg-3">
        <h6 class="text-white">Quick Links</h6>

        <ul class="list-unstyled small mb-0">
          <li><a (click)="scrollTo('mission')" class="nav-item">Mission</a></li>
          <li><a (click)="scrollTo('vision')" class="nav-item">Vision</a></li>
          <li><a (click)="scrollTo('values')" class="nav-item">Values</a></li>
          <li><a (click)="scrollTo('productservices')" class="nav-item">Products & Services</a></li>
          <li><a (click)="scrollTo('contactus')" class="nav-item">Contact us</a></li>
        </ul>


      </div>
    </div>
    <hr class="border-secondary my-4" />
    <div class="d-flex flex-column flex-md-row justify-content-end small">
      <span>© <span id="year"></span> - CodeDialog all rights reserved.</span>
    </div>
  </div>
</footer>